var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4 product-item-container"},[_c('div',{staticClass:"product-item",on:{"click":_vm.handleClick}},[_c('img',{ref:"img",attrs:{"src":_vm.item.src,"alt":_vm.item.text}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.item.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d6c7d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductItemImg.vue
// module id = null
// module chunks = 